eshopApp.controller('QuickRegisterController', ['$scope', '$http', '$rootScope', 'alertMessage', function($scope, $http, $rootScope, alertMessage){
	
	$scope.module_visible = false;
	$scope.spinner = true;
	$scope.valid_submit = true;
	$scope.existing_customer = false;

	$scope.formData = {};

	// Event listeners for display/hide and determining whether form should be displayed for 'registered' customer or 'guest'
    var showQuickRegister = $rootScope.$on('showQuickRegister', function(event, data){
    	$scope.getFormData();
        if (!$scope.existing_customer) {
	        if(data === "registered") {
	        	$scope.formData.customer_type = 'registered';
	        } else {
	        	$scope.formData.customer_type = 'guest';
	        }
    	}
        $scope.module_visible = true;
    });
    $scope.$on('$destroy', showQuickRegister);
    
    var hideQuickRegister = $rootScope.$on('hideQuickRegister', function(event){
        $scope.module_visible = false;
    });
    $scope.$on('$destroy', hideQuickRegister);

    // Unset linked customer data for Cart and reload
    $scope.reset = function() {
    	$http.get('a/unset/customer').success(function(){
    		location.reload();
    	});
    }

	// Get country list for form
	$scope.getCountries = function() {
		$http.get('/a/get_countries').success(function(response){
			if (response !== false) {
				$scope.countries = response.data;
			}
		}).finally(function(){		
			$scope.spinner = false;
		});
	}

	$scope.getCountries();

	// Get form data (if it has been set)
	$scope.getFormData = function() {
		$http.get('/m/quickregister').success(function(response){
			$scope.formData = {};
			if (response.message === 'success') {
				$scope.existing_customer = true;
				$scope.formData.customer_type = response.customer.registered === true ? 'registered' : 'guest';
				$scope.formData.firstname = response.customer.firstname;
				$scope.formData.lastname = response.customer.lastname;
				$scope.formData.company = response.customer.company;
				$scope.formData.vatnumber = response.customer.vatnumber;
				$scope.formData.email = response.customer.email;
				$scope.formData.phone = response.customer.phone;

				$scope.formData.address = response.billing_address.address;
				$scope.formData.postnumber = response.billing_address.postcode;
				$scope.formData.city = response.billing_address.city;
				$scope.formData.country = response.billing_address.country;
				$scope.formData.addr_label = response.billing_address.address_label;
	
				$scope.formData.separate_shipping = response.separate_shipping;

				if (response.separate_shipping == true) {
					$scope.formData.firstname_s = response.shipping_address.firstname;
					$scope.formData.lastname_s = response.shipping_address.lastname;
					$scope.formData.company_s = response.shipping_address.company;
					$scope.formData.address_s = response.shipping_address.address;
					$scope.formData.postnumber_s = response.shipping_address.postcode;
					$scope.formData.city_s = response.shipping_address.city;
					$scope.formData.country_s = response.shipping_address.country;
					$scope.formData.addr_label_s = response.shipping_address.address_label;
				}
			}
		}).finally(function(){

			// Set some default values for formData (if not already set)
			!$scope.formData.country ? $scope.formData.country = "FI" : '';
			!$scope.formData.country_s ? $scope.formData.country_s = "FI" : '';
			!$scope.formData.addr_label ? $scope.formData.addr_label = "A 01" : '';
			!$scope.formData.addr_label_s ? $scope.formData.addr_label_s = "S 01" : '';
			!$scope.formData.customer_type ? $scope.formData.customer_type = null : '';

		});
	}

	// Submit errors 
	$scope.submitErrors = {
		customerExists: false,
	}

	// Process form
	$scope.submitForm = function(isValid) {

		// Reset errors
		$scope.submitErrors.customerExists = false;

		angular.forEach($scope.qrform.$error.required, function(field) {
			field.$touched = true;
		});

		if (!isValid) {
			$scope.valid_submit = false;
			return false;	
		}
		
		$scope.valid_submit = true;
		$scope.spinner = true;

		// Post to backend
		$http.post('/customer', $scope.formData).success(function(response){
			// Success
			if (response.message === 'success') {
				if (response.alert) {
					alertMessage.set(response.alert, 'success');
				}
 				angular.element('.module_quickregister #qr_email').prop('readonly', true);
				$scope.nextStep();
			}

		}).error(function(response){

			// Customer with given email exists
			if(response.data === 'customer_exists') {
				$scope.submitErrors.customerExists = true;
			}

		}).finally(function(){
			$scope.spinner = false;
		});
	}

	// Continue
	$scope.nextStep = function() {
		$scope.module_visible = false;
		$rootScope.m_QuickLogin = false;
		$rootScope.m_AddressesSelector = false;
        $rootScope.m_FullCart = true;
        $rootScope.m_ShippingMethodSelector = true;
    }
    
}]);